import { School } from './types';

export const mockSchools: School[] = [
  {
    id: 'school-001',
    name: 'Oakridge Elementary',
    district: 'district-2', // Swun Unified School District
    address: '1234 Oakridge Lane, Springfield, CA 12345',
    logo: '/assets/images/schools/oakridge.png'
  },
  {
    id: 'school-002',
    name: 'Pinecrest Middle School',
    district: 'district-2', // Swun Unified School District
    address: '567 Pine Avenue, Springfield, CA 12345',
    logo: '/assets/images/schools/pinecrest.png'
  },
  {
    id: 'school-003',
    name: 'Riverside Elementary',
    district: 'district-1', // Riverside Unified School District
    address: '890 River Road, Springfield, CA 12345',
    logo: '/assets/images/schools/riverside.png'
  },
  {
    id: 'school-004',
    name: 'Lakeside K-8 Academy',
    district: 'district-2', // Swun Unified School District
    address: '1122 Lake Drive, Springfield, CA 12345',
    logo: '/assets/images/schools/lakeside.png'
  },
  {
    id: 'school-005',
    name: 'Sunnyside Elementary',
    district: 'district-2', // Swun Unified School District
    address: '3344 Sunny Boulevard, Springfield, CA 12345',
    logo: '/assets/images/schools/sunnyside.png'
  }
];